var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppFooterView',{attrs:{"main-menu-items":_vm.mainMenuItems,"help-support-menu-items":_vm.helpSupportMenuItems,"social-media-menu-items":_vm.socialMediaMenuItems,"account-menu-items":_vm.accountMenuItems,"shop-menu-items":_vm.shopMenuItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }